import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories } from '@/mocks/articles';

const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 4);

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat?.name || slug;
}

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '爆料网 - 全网最全爆料吃瓜平台',
    description:
      '每日实时追踪911爆料吃瓜、网红黑料、明星八卦与社会热点内幕。全网最全免费吃瓜平台。',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: articles.slice(0, 10).map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'NewsArticle',
          headline: article.title,
          url: `http://02office.cn/article/${article.slug}`,
          datePublished: article.publishDate,
          image: article.imageUrl,
          author: {
            '@type': 'Person',
            name: article.author,
          },
        },
      })),
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />

      <section className="relative w-full min-h-[580px] flex items-center bg-background-50 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20dramatic%20composition%20with%20flowing%20red%20and%20black%20gradients%2C%20mysterious%20atmosphere%2C%20artistic%20expression%2C%20no%20text%2C%20smooth%20gradients%2C%20editorial%20design%20background%2C%20bold%20contrast%2C%20cinematic%20mood&width=1920&height=800&seq=hero-bg-001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 mt-16">
          <div className="flex flex-col lg:flex-row items-start gap-12">
            <div className="flex-1">
              <h1 className="text-5xl md:text-7xl font-black text-foreground-950 font-heading leading-tight">
                全网最全
                <br />
                爆料吃瓜平台
              </h1>
            </div>
            <div className="flex-1 flex flex-col items-start gap-5 pt-4">
              <p className="text-foreground-600 text-base leading-relaxed max-w-md">
                实时追踪 911 爆料、网红黑料、明星八卦与社会热点内幕。作为全网最全免费吃瓜平台，为你独家揭秘最新动态。
              </p>
              <Link
                to="/category/wanghong-heiliao"
                className="text-primary-500 hover:text-primary-400 font-semibold text-sm flex items-center gap-1.5 transition-colors duration-200 cursor-pointer group"
              >
                最新爆料
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 -mt-8 pb-10">
          <div className="rounded-2xl overflow-hidden h-[280px] md:h-[380px]">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20collage%20style%20composition%20with%20entertainment%20news%20elements%2C%20abstract%20pop%20culture%20montage%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20dramatic%20mood%2C%20editorial%20design%2C%20bold%20visual%20impact%2C%20no%20text%2C%20artistic%20grain%20texture&width=1600&height=600&seq=hero-banner-001&orientation=landscape"
              alt="爆料网实时追踪最新爆料吃瓜动态"
              title="爆料网 - 全网最全爆料吃瓜平台"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-500/10 to-transparent rounded-2xl pointer-events-none"></div>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-8">
            <div>
              <h2 className="text-3xl font-bold text-foreground-950 font-heading">
                热门爆料
              </h2>
              <p className="text-foreground-600 text-sm mt-2">
                每日实时追踪，独家揭秘
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {hotArticles.map((article) => (
              <ArticleCard
                key={article.id}
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                category={article.category}
                categoryName={getCategoryName(article.category)}
                publishDate={article.publishDate}
                imageUrl={article.imageUrl}
                isHot={article.isHot}
                isExclusive={article.isExclusive}
                viewCount={article.viewCount}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-8">
            <div>
              <h2 className="text-3xl font-bold text-foreground-950 font-heading">
                独家揭秘
              </h2>
              <p className="text-foreground-600 text-sm mt-2">
                深度调查，真相只有一个
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {exclusiveArticles.map((article) => (
              <ArticleCard
                key={article.id}
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                category={article.category}
                categoryName={getCategoryName(article.category)}
                publishDate={article.publishDate}
                imageUrl={article.imageUrl}
                isHot={article.isHot}
                isExclusive={article.isExclusive}
                viewCount={article.viewCount}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-16">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
          <div className="inline-flex items-center gap-2 border border-primary-500/40 rounded-full px-4 py-1.5 mb-5">
            <span className="text-primary-500 text-xs font-semibold">爆料专区</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 font-heading mb-3">
            网红黑料 · 明星八卦 · 社会热点
          </h2>
          <p className="text-foreground-600 text-sm mb-10 max-w-xl mx-auto">
            四大专区覆盖全网最全爆料资源，你想看的都在这里
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="bg-background-200 rounded-2xl p-6 flex flex-col items-start text-left transition-all duration-300 hover:bg-primary-500 group cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-500/20 rounded-xl mb-4 group-hover:bg-background-50/20 transition-colors duration-300">
                  <i
                    className={`${cat.icon} text-primary-500 text-xl group-hover:text-background-50 transition-colors duration-300`}
                  ></i>
                </div>
                <h3 className="text-foreground-950 font-bold text-lg mb-2 group-hover:text-background-50 transition-colors duration-300">
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed group-hover:text-background-50/80 transition-colors duration-300">
                  {cat.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
